/**
 * Browser-safe environment (Vite `import.meta.env`). Server secrets must never live here.
 */
export function getPublicEnv() {
  const raw = import.meta.env.VITE_API_BASE_URL
  const apiBaseUrl =
    typeof raw === 'string' && raw.trim().length > 0 ? raw.trim() : '/api/v1'

  return {
    /** Base URL for REST (defaults to `/api/v1` when using Vite dev proxy). */
    apiBaseUrl,
    signalrHubUrl: import.meta.env.VITE_SIGNALR_HUB_URL,
    publicSiteUrl: import.meta.env.VITE_PUBLIC_SITE_URL,
    appFlavor: import.meta.env.VITE_APP_FLAVOR,
    /** Browser key for Google Maps. Restrict it by HTTP referrer, never reuse the server key. */
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    /** Public shortlisted / interview walk-in form URL. */
    shortlistedFormUrl: resolveShortlistedFormUrl(),
  } as const
}

const DEFAULT_SHORTLISTED_FORM_URL = 'https://shortlisted.amglobal.co'

function resolveShortlistedFormUrl(): string {
  const raw = import.meta.env.VITE_SHORTLISTED_FORM_URL
  if (typeof raw === 'string' && raw.trim().length > 0) {
    return raw.trim().replace(/\/$/, '')
  }
  return DEFAULT_SHORTLISTED_FORM_URL
}

/** Maps degrade to a coordinate list when no key is configured. */
export function getGoogleMapsApiKey(): string | null {
  const key = import.meta.env.VITE_GOOGLE_MAPS_API_KEY
  return typeof key === 'string' && key.trim().length > 0 ? key.trim() : null
}

/** Non-production workspace builds may use admin credentials on persona desks (e.g. pro.amglobal.dev). */
export function isNonProductionWorkspace(): boolean {
  const flavor = String(import.meta.env.VITE_APP_FLAVOR ?? '')
    .trim()
    .toLowerCase()
  return flavor === 'staging' || flavor === 'dev'
}
